import React, { useEffect, useState, useMemo, useRef } from "react";
import Swal from "sweetalert2";
import { CreateNewUser, getCountryCodeList, UpdateUser } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";

const EditUser = ({ setEditCpModal, editData, getAllData }) => {
  const [editCpForm, setEditCpForm] = useState({
    firstName: editData?.firstName || "",
    lastName: editData?.lastName || "",
    emailId: editData?.email || "",
    password: editData?.password || "",
    mobileNumber: editData?.mobileNo || "",
    
  });
  const [countryList, setCountryList] = useState([]);
  const [editError, setEditError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [searchCountry, setSearchCountry] = useState("");
  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  const pass = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  const phoneRegex = /^[6-9]\d{9}$/;
  const dropdownRef = useRef(null);

  // Filter countries based on search
  const filteredCountries = useMemo(() => {
    return countryList.filter((country) =>
      country.nicename.toLowerCase().includes(searchCountry.toLowerCase()) ||
      country.phonecode.toString().includes(searchCountry)
    );
  }, [countryList, searchCountry]);

  // Initialize phone number from editData
  useEffect(() => {
    if (editData?.mobileNo) {
      const cleanNumber = editData.mobileNo.replace(/^\+/, '');
      // Find country by phone code
      const country = countryList.find(c => cleanNumber.startsWith(c.phonecode));
      
      if (country) {
        setSelectedCountry(country);
        // Remove country code and set remaining digits as mobile number
        const numberWithoutCode = cleanNumber.slice(country.phonecode.toString().length);
        setEditCpForm(prev => ({
          ...prev,
          mobileNumber: numberWithoutCode
        }));
      }
    }
  }, [editData?.mobileNo, countryList]);

  // Add this useEffect to handle outside clicks
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // edit cp
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      emailId,
      mobileNumber,
    } = editCpForm;
    if (
      !firstName ||
      !lastName ||
      !emailId ||
      !emailRegex.test(emailId) ||
      !mobileNumber ||
      (mobileNumber && !phoneRegex.test(mobileNumber))
     
    ) {
      setEditError(true);
    } else {
      setEditError(false);

      let payload = {
        id: editData?.id,
        firstName: firstName,
        lastName: lastName,
        mobileNo: `+${selectedCountry?.phonecode + mobileNumber}`,
        email: emailId,
        cpDetailsList: [],
      };
      const response = await UpdateUser(payload);
      console.log("responseCreateUser", response);
      if (response?.statusDescription?.status == 200) {
        getAllData();
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
        setEditCpModal(false);

        setEditCpForm((prev) => ({
          ...prev,
          firstName: "",
          lastName: "",
          emailId: "",
          mobileNumber: "",
        }));
      } else {
        Swal.fire({
          icon: "info",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCountryCodeList();
        if (response?.countryList) {
          setCountryList(response.countryList);
          // Find and set India as default
          const india = response.countryList.find(
            (country) => country.iso === "IN"
          );
          if (india) {
            setSelectedCountry(india);
          }
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  return (
    <form class="form-horizontal" onSubmit={handleEditSubmit}>
      <div class="row mb-1">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="">
              First Name<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${
                editError && !editCpForm.firstName ? "is-invalid" : ""
              }`}
              maxlength="100"
              name="firstName"
              placeholder="First Name"
              autocomplete="FirstName"
              value={editCpForm.firstName}
              onChange={(e) =>
                setEditCpForm((prev) => ({
                  ...prev,
                  firstName: e.target.value,
                }))
              }
              onKeyPress={(e) => {
                if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {editError && !editCpForm.firstName && (
              <div class="invalid-feedback d-block error">
                <div>First Name is required.</div>
              </div>
            )}
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="">
              Last Name<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${
                editError && !editCpForm.lastName ? "is-invalid" : ""
              }`}
              autocomplete="LastName"
              placeholder="Last Name"
              maxlength="30"
              name="lastName"
              value={editCpForm.lastName}
              onChange={(e) =>
                setEditCpForm((prev) => ({
                  ...prev,
                  lastName: e.target.value,
                }))
              }
              onKeyPress={(e) => {
                if (!/^[a-zA-Z\s]+$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {editError && !editCpForm.lastName && (
              <div class="invalid-feedback d-block error">
                <div>Last Name is required.</div>
              </div>
            )}
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label class="">
              Email Id<sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class={`form-control ${
                editError && !editCpForm.emailId ? "is-invalid" : ""
              }`}
              autocomplete="EmailId"
              placeholder="Email Id"
              maxlength="70"
              name="emailId"
              value={editCpForm.emailId}
              onChange={(e) =>
                setEditCpForm((prev) => ({
                  ...prev,
                  emailId: e.target.value,
                }))
              }
            />
            {editError &&
              (!editCpForm.emailId || !emailRegex.test(editCpForm.emailId)) && (
                <div className="invalid-feedback d-block error">
                  {!editCpForm.emailId
                    ? "Please enter an email id"
                    : editCpForm.emailId && !emailRegex.test(editCpForm.emailId)
                    ? "Please enter a valid email id"
                    : ""}
                </div>
              )}
          </div>
        </div>
        <div class="col-sm-6">
          <div className="form-group">
            <label className="">
              Mobile<sup className="text-danger">*</sup>
            </label>
            <div className="phone-input-container" ref={dropdownRef}>
              <div
                className="phone-select"
                onClick={() => setShowCountryDropdown(!showCountryDropdown)}
              >
                {selectedCountry ? (
                  <>
                    <img
                      src={`https://flagcdn.com/w20/${selectedCountry.iso.toLowerCase()}.png`}
                      alt={selectedCountry.nicename}
                      className="flag-icon"
                    />
                    <span className="country-code">
                      +{selectedCountry.phonecode}
                    </span>
                    <i className="fas fa-chevron-down arrow-icon"></i>
                  </>
                ) : (
                  <span>Select Country</span>
                )}
              </div>
              <input
                type="text"
                className={`form-control mobile-input ${
                  editError &&
                  (!editCpForm.mobileNumber ||
                    editCpForm.mobileNumber.length !== selectedCountry?.msisdnLength)
                    ? "is-invalid"
                    : ""
                }`}
                placeholder={`Enter ${selectedCountry?.msisdnLength || 10} digit number`}
                maxLength={selectedCountry?.msisdnLength || 10}
                value={editCpForm.mobileNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (
                    selectedCountry &&
                    value.length <= selectedCountry.msisdnLength
                  ) {
                    setEditCpForm((prev) => ({
                      ...prev,
                      mobileNumber: value,
                    }));
                  }
                }}
              />

              {showCountryDropdown && (
                <div className="country-dropdown">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search country..."
                    value={searchCountry}
                    onChange={(e) => setSearchCountry(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div className="country-list">
                    {filteredCountries.map((country) => (
                      <div
                        key={country.id}
                        className={`country-item ${
                          selectedCountry?.id === country.id ? 'active' : ''
                        }`}
                        onClick={() => {
                          setSelectedCountry(country);
                          setShowCountryDropdown(false);
                          setSearchCountry("");
                          setEditCpForm((prev) => ({
                            ...prev,
                            mobileNumber: "",
                          }));
                        }}
                      >
                        <img
                          src={`https://flagcdn.com/w20/${country.iso.toLowerCase()}.png`}
                          alt={country.nicename}
                          className="flag-icon"
                        />
                        <span className="country-name">{country.nicename}</span>
                        <span className="country-code">
                          +{country.phonecode}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {editError &&
              (!editCpForm.mobileNumber ||
                editCpForm.mobileNumber.length !== selectedCountry?.msisdnLength) && (
                <div className="invalid-feedback d-block">
                  {!editCpForm.mobileNumber
                    ? "Please enter a mobile number"
                    : `Please enter a valid ${selectedCountry?.msisdnLength}-digit mobile number`}
                </div>
              )}
          </div>
        </div>
      </div>

    
      <div class="modal-footer pb-0 border-0 justify-content-between mx-0 px-0">
        <button
          type="button"
          className="btn btn-danger btn-raised m-0"
          data-dismiss="modal"
          onClick={() => {
            setEditCpModal(false);
            setEditError(false);
          }}
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-primary btn-raised m-0">
          Submit
        </button>
      </div>
    </form>
  );
};

export default EditUser;
